import '../../_helpers/sort-by.js'
export const listCampaignType = [
    {value:'NATIVE', label:'Native'},
    {value:'DISPLAY', label:'Display'},
    {value:'VIDEO', label:'Video'},
    {value:'PUSH_NOTIFICATION', label:'Push Notification'},
    // {value:'DISPLAY_BANNER', label:'Display Banner'},
].sortBy('label')